module.exports = __webpack_public_path__ + "media/images/icon__arrow-right@3x-337a5fccbccf2fbfdc99724445679bd5.png";